import { Reducer } from "redux"
import { InputItemType, Theme } from "./types"
import { sortByAppearanceInDomTree } from "../../core/helpers/webcomponent-helpers"
import { add, remove } from "../../core/helpers/immutability-helpers"

export interface InputGroupState {
  theme: Theme
  type: InputItemType
  name?: string
  inline: boolean
  reappending: boolean
  reappendedItems: number
  inputItemEls: HTMLSdxInputItemElement[]
  selectedInputItemEls: HTMLSdxInputItemElement[]
}

export type InputGroupActions =
  | { type: "UPDATE_REAPPENDING" }
  | { type: "SELECT"; inputItemEl: HTMLSdxInputItemElement }
  | {
      type: "ADD_INPUT_ITEM_EL"
      inputItemEl: HTMLSdxInputItemElement
    }
  | {
      type: "REMOVE_INPUT_ITEM_EL"
      inputItemEl: HTMLSdxInputItemElement
    }

export const inputGroupReducer: Reducer<InputGroupState, InputGroupActions> = (
  state = {} as InputGroupState,
  action
): InputGroupState => {
  switch (action.type) {
    case "UPDATE_REAPPENDING":
      const reappendedItems = state.reappendedItems + 1
      const reappending = reappendedItems !== state.inputItemEls.length

      return {
        ...state,
        reappending,
        reappendedItems: reappending ? reappendedItems : 0,
      }

    case "SELECT":
      let selectedInputItemEls = state.selectedInputItemEls

      if (state.type === "radio") {
        const alreadySelected =
          state.selectedInputItemEls[0] === action.inputItemEl

        if (alreadySelected) {
          selectedInputItemEls = []
        } else {
          selectedInputItemEls = [action.inputItemEl]
        }
      } else {
        // "checkbox"
        const selectionIndex = state.selectedInputItemEls.indexOf(
          action.inputItemEl
        )
        const alreadySelected = selectionIndex > -1

        if (alreadySelected) {
          // remove from selection
          selectedInputItemEls = selectedInputItemEls.filter(
            (inputItemElFromSelection) =>
              inputItemElFromSelection !== action.inputItemEl
          )
        } else {
          // add to selection
          selectedInputItemEls = [...selectedInputItemEls, action.inputItemEl]
        }
      }

      return {
        ...state,
        selectedInputItemEls,
      }

    case "ADD_INPUT_ITEM_EL":
      return {
        ...state,
        inputItemEls: add(state.inputItemEls, action.inputItemEl).sort(
          sortByAppearanceInDomTree
        ),
      }

    case "REMOVE_INPUT_ITEM_EL":
      return {
        ...state,
        inputItemEls: remove(state.inputItemEls, action.inputItemEl).sort(
          sortByAppearanceInDomTree
        ),
      }

    default:
      return state
  }
}

export function getInitialState(): InputGroupState {
  return {
    type: "radio",
    theme: "none",
    name: "",
    inline: false,
    reappending: false,
    reappendedItems: 0,
    selectedInputItemEls: [],
    inputItemEls: [],
  }
}
